import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import ArticlesGrid from "../../../Components/Layouts/Content/Read/ArticlesGrid";
import ArticleTopics from "../../../Components/Layouts/Content/Read/ArticleTopics";
import { UserAuthenticationContext } from "../../../Context/UserAuthenticationContext";
import { SetTitle } from "../../../Helpers/PageMetadata";
import useFetchArticleCategories from "../../../Hooks/Content/Read/useFetchArticleCategories";
import useFetchArticleCategoryFeed from "../../../Hooks/Content/Read/useFetchArticleCategoryFeed";

function CategoryFeed({ categoryId }: { categoryId: number }) {
    const { doesAuthTokenExist } = useContext(UserAuthenticationContext);
    const { categories, categoriesLoading, categoriesError, retryCategories } = useFetchArticleCategories();
    const { articles, featuredArticle, featuredIsStaffPick, category, loading, hasMore, error, loadMore, retry } = useFetchArticleCategoryFeed(categoryId);

    useEffect(() => { SetTitle(category?.title || "Articles"); }, [category]);

    const retryFailedRequests = () => {
        if (error) void retry();
        if (categoriesError) retryCategories();
    };

    return <div className="page page--read">
        <header className="article-feed__header">
            <p className="article-feed__eyebrow">Explore a topic</p>
            <h1>{category?.title || "Articles"}</h1>
            <p>Perspectives and the latest stories from our contributors.</p>
        </header>
        <ArticleTopics categories={categories} selectedId={categoryId}/>
        {(error || categoriesError) && <div className="article-feed__notice" role="alert">
            {error && <p>{error}</p>}
            {categoriesError && <p>{categoriesError}</p>}
            <button type="button" onClick={retryFailedRequests} disabled={loading || categoriesLoading}>Try again</button>
        </div>}
        <ArticlesGrid mode="editorial" featuredArticle={featuredArticle} featuredIsStaffPick={featuredIsStaffPick}
            articleGroups={articles.length ? [{ Id: categoryId, Title: "", Articles: articles }] : []}
            disableLoadMore={!hasMore} loadMoreUpdate={() => void loadMore()} isLoading={loading}
            doesAuthTokenExist={doesAuthTokenExist()}
            emptyMessage="There are no published articles in this topic yet."/>
    </div>;
}

export default function ArticleCategoryScreen() {
    const { id } = useParams();
    // Remount when navigating directly between topics so previous pages never
    // flash under the next topic's heading or retain its pagination offset.
    return <CategoryFeed key={id} categoryId={Number(id)}/>;
}